const NAV_NEWSLETTER_BASE = '/newsletter';


export const NAV_NEWSLETTER_SUBSCRIBED = `${NAV_NEWSLETTER_BASE}/subscribed`;
